import { ShareType } from "../models/share-type";

export class UpdateUserShareTypeRequest{
    planogramId: string = '';
    stateId: string = '';
    targetUserId: string = '';
    shareType: ShareType;
    constructor(planogramId: string, stateId: string, targetUserId: string, shareType: ShareType){
        this.planogramId = planogramId;
        this.stateId = stateId;
        this.targetUserId = targetUserId;
        this.shareType = shareType;
    }
}
